import type { RoleUtilisateur } from './api/types'

/**
 * Libellé français d'un rôle.
 *
 * Dans son propre fichier, et non à côté du composant `RouteProtegee` : un
 * module qui exporte à la fois des composants et des fonctions casse le
 * rafraîchissement à chaud de Vite, et c'est le genre de gêne qu'on subit
 * cent fois par jour sans jamais prendre le temps de la corriger.
 */
export function libelleRole(role: RoleUtilisateur): string {
  switch (role) {
    case 'TITULAIRE':
      return 'titulaire'
    case 'COLLABORATEUR':
      return 'collaborateur'
    case 'REMPLACANT':
      return 'remplaçant'
  }
}
